import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule, NgFor, NgIf } from '@angular/common';
import { ChangeDetectorRef, Component, ElementRef, inject, Input, OnInit, OnChanges, QueryList, SimpleChanges, ViewChildren } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { SharedModule } from '@processo/shared/shared.module';
import { StateService } from '@processo/shared/state/state.service';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzSwitchModule } from 'ng-zorro-antd/switch';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { CustomInputDirective } from '../entity-layout/smart-table/smart-cell/directives/input.directive';
import { MultiDropdownDirective } from '../entity-layout/smart-table/smart-cell/directives/multi-dropdown.directive';
import { SingleDropdownDirective } from '../entity-layout/smart-table/smart-cell/directives/single-dropdown.directive';
import { PriorityDirective } from '../entity-layout/smart-table/smart-cell/directives/priority.directive';
import { TagDropdownDirective } from '../entity-layout/smart-table/smart-cell/directives/tag-dropdown.directive';
import { StatusDropdownDirective } from '../entity-layout/smart-table/smart-cell/directives/status-dropdown.directive';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { PeopleDirective } from '../entity-layout/smart-table/smart-cell/directives/people.directive';
import { DateDirective } from '../entity-layout/smart-table/smart-cell/directives/date.directive';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { CheckboxDirective } from '../entity-layout/smart-table/smart-cell/directives/checkbox.directive';
import { ProgressDirective } from '../entity-layout/smart-table/smart-cell/directives/progress.directive';
import { NzSliderModule } from 'ng-zorro-antd/slider';
import { FileAttachmentDirective } from '../entity-layout/smart-table/smart-cell/directives/file-attachment.directive';
import { RatingsDirective } from '../entity-layout/smart-table/smart-cell/directives/ratings.directive';
import { TimeDirective } from '../entity-layout/smart-table/smart-cell/directives/time.directive';
import { PhoneCodeDirective } from '../entity-layout/smart-table/smart-cell/directives/phone-code.directive';
import { DateTimeDirective } from '../entity-layout/smart-table/smart-cell/directives/datetime.directive';
import { format, startOfMonth, endOfMonth, addDays, subDays, startOfDay, endOfDay, isToday, isYesterday } from 'date-fns';

import { datatypesOperator, filter_number, filter_string, get_key3_between_format, number_datatype, string_datatype } from '@processo/consts/filter.const';
import { isScriptExist, script_error_text } from '@processo/consts/show_error';
import { FilterSelectEntityFieldComponent } from "../filter-select-entity-field/filter-select-entity-field.component";
import { layoutCache } from '../entity-layout/smart-table/cache';

@Component({
  selector: 'app-entity-filter-datatype',
  templateUrl: './entity-filter-datatype.component.html',
  styleUrls: ['./entity-filter-datatype.component.scss'],
  standalone: true,
  imports: [
    NgFor,
    NzGridModule,
    NzSwitchModule,
    FormsModule,
    NgIf,
    NzSelectModule,
    NzInputModule,
    NzToolTipModule,
    CommonModule,
    NzTabsModule,
    // SharedModule,
    DragDropModule,
    CustomInputDirective,
    MultiDropdownDirective,
    SingleDropdownDirective,
    PriorityDirective,
    TagDropdownDirective,
    StatusDropdownDirective,
    NzIconModule,
    NzLayoutModule,
    PeopleDirective,
    DateDirective,
    NzDatePickerModule,
    CheckboxDirective,
    RatingsDirective,
    ProgressDirective,
    NzSliderModule,
    FileAttachmentDirective,
    TimeDirective,
    PhoneCodeDirective,
    DateTimeDirective,
    FilterSelectEntityFieldComponent
  ],
})
export class EntityFilterDatatypeComponent implements OnInit, OnChanges {
  Array = Array;
  @Input() filters: any;
  @Input() default_data: any;
  exe_api_payload_all_field: any;
  @ViewChildren('formElement') formElement!: QueryList<ElementRef<any>>;
  private actualMainEntity: string = '';
  // New properties for combined dropdown functionality
  expandedEntities: { [key: string]: boolean } = {};
  searchTerm: string = '';
  @ViewChildren('fieldSelect') fieldSelects!: QueryList<any>;
  isScriptExist = isScriptExist;
  script_error_text: string = script_error_text;
  private stateService = inject(StateService);
  constructor(private cdr: ChangeDetectorRef) { }

  getPeopleTooltipTitle(peopleData: any): string {
    if (!peopleData) return '';

    // Normalise to a flat list of non-empty string values. People can arrive as a
    // single string, a flat array, or a nested array.
    const values = (Array.isArray(peopleData) ? peopleData : [peopleData])
      .flat(Infinity)
      .filter((v: any) => v !== null && v !== undefined && v !== '')
      .map((v: any) => this.resolvePeopleName(v));

    return values.join(', ');
  }

  /** Resolve the LOGGED_IN_USER placeholder to the actual user's full name. */
  private resolvePeopleName(value: any): string {
    if (value !== 'LOGGED_IN_USER') return String(value);
    try {
      const loggedIn = this.stateService.isUserLoggedIn()?.userDetail as any;
      const attrs = loggedIn?.attributes || {};
      return attrs?.first_name && attrs?.last_name
        ? `${attrs.first_name} ${attrs.last_name}`
        : (loggedIn?.user_name || loggedIn?.name || loggedIn?.display_name || String(value));
    } catch {
      return String(value);
    }
  }
  initialSetFilter: boolean = true
  ngOnInit(): void {
    // Store the main entity's name on initialization for later reference
    this.actualMainEntity = this.default_data?.entity?.name;
    if (layoutCache.has('filterApplied')) {
      this.filters = []
    }
    if (this.filters.length == 0) {
      this.filters.push({
        entity_name: this.actualMainEntity,
        key1: '',
        key2: '',
        key4: true,
        key3: '',
      });
    }
    this.exe_api_payload_all_field = {
      from: 'table_filter',
      filter: {},
    };
    if (this.Array.isArray(this.filters) && this.filters?.length > 0) {
      this.initialSetFilter = this.filters[0]?.key4
    }

    this.formatDefaultFilter(this.filters);
  }
  formatDefaultFilter(filter: any): any {
    if (Array.isArray(filter)) {
      filter.forEach((item: any) => this.formatDefaultFilter(item));
      return filter;
    }
    if (filter && typeof filter === 'object') {
      if (filter.key2 === '$btw') {
        const fields = this.getFields(filter?.entity_name);
        let key1Value = filter?.key1
        if (key1Value?.includes('~')) {
          key1Value = key1Value?.split('~')?.[1]
        }
        const selectedField = fields?.find((item: any) => item?.name === key1Value);
        const betweenValue = this.getBetweenTypeValue(selectedField, filter.key3)
        if (filter.key3 && typeof filter.key3 === 'object') {
          filter.key3 = betweenValue;
        }
      }
      Object.keys(filter).forEach((k) => {
        const v = filter[k];
        if (Array.isArray(v)) {
          this.formatDefaultFilter(v);
        }
      });
      return filter;
    }
    return filter;
  }
  getBetweenTypeValue(field: any, value: any) {
    const newValue = get_key3_between_format(
      value, '$btw', field
    )
    return newValue
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['filters']) {
      // Use the same reference so mutations propagate back to the parent filterby
      const newFilters = changes['filters'].currentValue;
      this.filters = Array.isArray(newFilters) ? newFilters : [];

      // Initialize with default if empty
      if (this.filters.length === 0) {
        this.filters.push({
          entity_name: this.actualMainEntity || this.default_data?.entity?.name,
          key1: '',
          key2: '',
          key4: true,
          key3: '',
        });
      }
      // Force change detection
      const updatedFilter = this.formatDefaultFilter(this.filters);
      this.filters = updatedFilter;
      //console.log(this.filters, 'this.filters')
      this.cdr.detectChanges();
    }
  }

  addGroup() {

    this.filters.push([
      {
        entity_name: this.default_data.entity.name,
        key1: '',
        key2: '',
        key4: !this.initialSetFilter,
        key3: '',
      },
    ]);
  }
  addNewFilter() {
    const defaultKey4 = this.filters && this.filters.length > 0 && this.filters[0] && typeof this.filters[0].key4 !== 'undefined' ? this.filters[0].key4 : true;
    this.filters.push({
      entity_name: this.default_data?.entity?.name,
      key1: '',
      key2: '',
      key4: this.initialSetFilter,
      key3: '',
    });
  }
  addNewGroupFilter(i: any) {
    this.filters[i].push({
      entity_name: this.default_data.entity.name,
      key1: '',
      key2: '',
      key4: !this.initialSetFilter,
      key3: '',
    });
  }

  addChildGroup(i: any) {
    this.filters[i].push([
      {
        entity_name: this.default_data.entity.name,
        key1: '',
        key2: '',
        key4: this.initialSetFilter,
        key3: '',
      },
    ]);
  }

  clearGroup(index: any) {
    this.filters.splice(index, 1);
  }
  addNewChildFilter(i: any, j: any) {
    this.filters[i][j].push({
      entity_name: this.default_data.entity.name,
      key1: '',
      key2: '',
      key4: this.initialSetFilter,
      key3: '',
    });
  }

  clearChildGroup(i: any, j: any) {
    this.filters[i].splice(j, 1);
  }
  show_delete(filter: any) {
    let value: any = [];
    filter.forEach((_e: any) => {
      if (!Array.isArray(_e)) {
        value.push(_e);
      }
    });
    if (value?.length > 1) {
      return true;
    }
    return false;
  }
  private shouldShowFieldInEntity(field: any, entityName: string): boolean {
    // If we are listing fields for the main entity itself, always show them.
    if (entityName === this.actualMainEntity) {
      return true;
    }

    // For parent entities, hide fields that are identified as relationship links.
    const isRelationship = this.isRelationshipField(field, entityName, this.actualMainEntity);
    return !isRelationship;
  }

  // Update isRelationshipField to use the stored main entity
  private isRelationshipField(field: any, fieldEntityName: string, actualMainEntityName: string): boolean {
    // This check only applies to fields that belong to a parent entity.
    if (fieldEntityName === actualMainEntityName) {
      return false;
    }

    const mainEntity = this.default_data.meta_data?.entities?.find((e: any) => e.name === actualMainEntityName);
    if (!mainEntity) {
      return false;
    }

    // Find if a dropdown field in the main entity uses this specific parent field as its data source.
    const isUsedAsDataSource = mainEntity.fields.some((mainEntityField: any) =>
      // 1. Is the main entity's field an ENTITY_DATA dropdown?
      (mainEntityField.datatype === 'dropdown_single_select' || mainEntityField.datatype === 'dropdown_multi_select') &&
      mainEntityField.option_type === 'ENTITY_DATA' &&

      // 2. Does its name match the parent field's name?
      mainEntityField.name === field.name &&

      // 3. (THE CRUCIAL FIX) Does it point specifically to the parent entity we are currently checking?
      mainEntityField.entity_name === fieldEntityName
    );

    if (isUsedAsDataSource) {
      // Hide the field only if all three conditions are met.
      return true;
    }

    return false;
  }
  getFields(entityName: any) {
    let entity_Name = this.default_data.child_data?.find(
      (_e: any) => _e?.field_name === entityName
    )?.entity_name;

    // If entity_Name is undefined, it means this is the main entity
    if (!entity_Name) {
      // Check if entityName exists as an entity name in child_data
      const childDataEntry = this.default_data.child_data?.find(
        (cd: any) => cd.entity_name === entityName
      );
      //console.log('Child data entry found:', childDataEntry);

      if (childDataEntry) {
        // This is a child entity name, use it directly
        entity_Name = entityName;
        //console.log('Using child entity name directly:', entity_Name);
      } else {
        // If still undefined, it means this is the main entity
        entity_Name = this.actualMainEntity;
        // console.log('Using main entity name:', entity_Name);
      }
    }

    const entity = this.default_data.meta_data?.entities
      .find((e: any) => e.name === entity_Name);
    const allFields = entity?.fields?.filter(
      (e: any) =>
        e?.datatype !== 'entity' &&
        e?.datatype !== 'textarea'
    );
    const fields = allFields?.filter((e: any) =>
      this.shouldShowFieldInEntity(e, entity_Name) // This calls the updated logic
    );
    //console.log('Fields after shouldShowFieldInEntity filtering:', fields?.length || 0);

    const result = fields?.sort((a: any, b: any) => a.label?.localeCompare(b.label));
    //console.log('Final result:', result?.length || 0);
    return result;
  }
  filterTypeFieldChange(event: any, i: any, entityName: any) {
    const fields = this.getFields(entityName);
    const selectedField = fields?.find((item: any) => item?.name === event);
    if (selectedField) {
      if (
        [
          'dropdown_single_select',
          'people',
          'dropdown_multi_select',
          'status',
          'tag',
          'priority',
          'phone',
          'website',
          'email',
          'textbox',
          'location',
        ].includes(selectedField?.datatype)
      ) {
        this.filters[i].key3 = [];
      }
      if (
        [
          'currency',
          'progress',
          'number',
          'ratings',
          'rating',
          'time',
        ].includes(selectedField?.datatype)
      ) {
        this.filters[i].key3 = null;
      }
      const operators = this.getOperators(this.filters[i]?.key1, entityName) || [];
      if ([
        'textbox', 'dropdown_single_select', 'dropdown_multi_select', 'status', 'tag', 'priority', 'phone', 'website', 'people', 'email', 'location'
      ].includes(selectedField?.datatype)) {
        const inOp = operators.find((op: { label: string; value: string }) => op.label === 'in');
        this.filters[i].key2 = inOp ? inOp.value : (operators[0]?.value || '');
      } else if (selectedField?.datatype === 'date' || selectedField?.datatype === 'datetime') {
        const btwOp = operators.find((op: { label: string; value: string }) => op.label === 'between');
        this.filters[i].key2 = btwOp ? btwOp.value : (operators[0]?.value || '');
      } else if ([
        'number', 'currency', 'progress', 'ratings', 'rating', 'time'
      ].includes(selectedField?.datatype)) {
        const eqOp = operators.find((op: { label: string; value: string }) => op.label === '=' || op.label === 'is');
        this.filters[i].key2 = eqOp ? eqOp.value : (operators[0]?.value || '');
      } else if (selectedField?.datatype === 'checkbox') {
        const selOp = operators.find((op: { label: string; value: string }) => op.label === 'is selected');
        this.filters[i].key2 = selOp ? selOp.value : (operators[0]?.value || '');
      } else if (selectedField?.datatype === 'attachment') {
        const hasOp = operators.find((op: { label: string; value: string }) => op.label === 'has');
        this.filters[i].key2 = hasOp ? hasOp.value : (operators[0]?.value || '');
        this.filters[i].key3 = 'true'; // Default to "has" = true
      } else {
        this.filters[i].key2 = operators[0]?.value || '';
      }
    }
  }
  // Handle search input change
  onSearchChange(event: any) {
    this.searchTerm = event.target?.value?.toLowerCase() || '';
  }

  // Check if entity should be shown based on search
  shouldShowEntity(entityLabel: string): boolean {
    if (!this.searchTerm) return true;

    // Show entity if any of its fields match the search term
    const entityName = this.getEntityNameByLabel(entityLabel);
    const allFields = entityName === this.default_data?.entity?.name
      ? [...this.getMainEntityPriorityFields(), ...this.getMainEntityNonPriorityFields()]
      : [...this.getChildEntityPriorityFields(entityName), ...this.getChildEntityNonPriorityFields(entityName)];

    return allFields.some(field =>
      field.label.toLowerCase().includes(this.searchTerm) ||
      entityLabel.toLowerCase().includes(this.searchTerm)
    );
  }

  // Get entity name by label (helper method)
  getEntityNameByLabel(entityLabel: string): string {
    if (entityLabel === this.default_data?.entity?.display_name) {
      return this.default_data?.entity?.name;
    }
    const childData = this.default_data?.child_data?.find((c: any) => c.label === entityLabel);
    return childData?.entity_name || '';
  }

  // Toggle expansion state for an entity
  toggleEntityExpansion(entityKey: string) {
    this.expandedEntities[entityKey] = !this.expandedEntities[entityKey];
  }

  // Select a field with specific filter parameter - FIXED VERSION
  selectFieldWithFilter(entityName: string, fieldName: string, fieldLabel: string, filter: any, isChild: boolean = false) {
    filter.entity_name = entityName;


    // Check if this is a parent-child relationship
    // If isChild is true, FORCE composite key even if names match (resolves collision bug)
    const currentEntityName = this.default_data?.entity?.name;
    if (isChild || entityName !== currentEntityName) {
      // This is a parent-child filter, create composite key
      filter.key1 = `${entityName}~${fieldName}`;
    } else {
      filter.key1 = fieldName;
    }

    filter.key2 = '';
    filter.key3 = '';

    // Find the filter index for setting default operator
    const filterIndex = this.filters.indexOf(filter);
    if (filterIndex === -1) {
      // If filter is inside an array (group), find its parent
      for (let i = 0; i < this.filters.length; i++) {
        if (Array.isArray(this.filters[i])) {
          const subIndex = this.filters[i].indexOf(filter);
          if (subIndex !== -1) {
            this.filterTypeFieldChange(fieldName, i, entityName);
            break;
          }
        }
      }
    } else {
      this.filterTypeFieldChange(fieldName, filterIndex, entityName);
      this.set_key2value(filter.key2, filter);
    }

    // Clear search term
    this.searchTerm = '';

    // Close dropdown - improved approach
    setTimeout(() => {
      // Try multiple methods to ensure dropdown closes
      const selectElements = document.querySelectorAll('nz-select');
      selectElements.forEach((select: any) => {
        if (select.blur) {
          select.blur();
        }
        // Also try to close via nz-select service
        if (select.nzSelectService) {
          select.nzSelectService.setOpenState(false);
        }
      });

      // Fallback: simulate outside click
      document.body.click();
    }, 50);
  }

  // Check if a field is currently selected - Updated to use specific filter
  isSelected(entityName: string, fieldName: string, filter: any, isChild: boolean = false): boolean {
    const currentEntityName = this.default_data?.entity?.name;

    if (isChild || entityName !== currentEntityName) {
      // For parent-child relationships, check for composite key
      const compositeKey = `${entityName}~${fieldName}`;
      return filter?.entity_name === entityName && filter?.key1 === compositeKey;
    } else {
      // For same entity, check regular field name
      return filter?.entity_name === entityName && filter?.key1 === fieldName;
    }
  }

  // Updated onCombinedFieldSelection
  onCombinedFieldSelection(value: string, filter: any) {
    //console.log(value, 'value')
    if (!value) {
      filter.entity_name = '';
      filter.key1 = '';
      filter.key2 = '';
      filter.key3 = '';
      return;
    }

    const [entityName, fieldName] = value.split('|');
    filter.entity_name = entityName;

    // Check if this is a parent-child relationship
    const currentEntityName = this.default_data?.entity?.name;
    if (entityName !== currentEntityName) {
      // This is a parent-child filter, create composite key
      filter.key1 = `${entityName}~${fieldName}`;
    } else {
      filter.key1 = fieldName;
    }

    filter.key2 = '';
    filter.key3 = '';

    const filterIndex = this.filters.indexOf(filter);
    this.filterTypeFieldChange(fieldName, filterIndex, entityName);
  }

  // Helper method to get current combined value for display
  getCombinedValue(filter: any) {
    ;

    if (filter?.entity_name && filter?.key1) {
      // Check if this is a parent-child filter by looking for ~ in key1
      if (filter.key1.includes('~')) {
        // For parent-child filters like {entity_name: 'pn', key1: 'pn~cs'}
        // Only show the child field name, not "Parent > Child"
        return this.getChildFieldNameOnly(filter);
      } else {
        // Regular field - show only field label
        const fieldLabel = this.getFieldLabelByName(filter.entity_name, filter.key1);
        //console.log('fieldLabel:', fieldLabel);
        //console.log('Final result:', fieldLabel);
        return fieldLabel;
      }
    }
    // console.log('Returning null - missing entity_name or key1');
    return null;
  }

  // New helper method to get only the child field name for parent-child filters
  private getChildFieldNameOnly(filter: any): string {
    //console.log('getChildFieldNameOnly called with:', filter);

    // Parse the composite key: 'pn~cs' -> parentField='pn', childField='cs'
    const [parentField, childField] = filter.key1.split('~');
    //console.log('Parsed parent field:', parentField, 'child field:', childField);

    // Resolve child entity via child_data map
    const childMap = this.default_data?.child_data?.find((cd: any) => cd.field_name === parentField);
    if (childMap?.entity_name) {
      const childFieldLabel = this.getChildFieldLabel(childMap.entity_name, childField);
      return childFieldLabel;
    }
    // Fallback - return just the child field name
    return childField;
  }

  // Keep the existing getChildFieldLabel method
  private getChildFieldLabel(childEntityName: string, fieldName: string): string {
    //console.log('getChildFieldLabel called with:', childEntityName, fieldName);

    // Get fields from the child entity
    const childEntity = this.default_data?.meta_data?.entities?.find((e: any) => e.name === childEntityName);
    const childFields = childEntity?.fields?.filter(
      (e: any) =>
        e?.datatype !== 'entity' &&
        e?.datatype !== 'textarea'
    );

    //console.log('Child entity fields:', childFields?.length || 0);

    const field = childFields?.find((f: any) => f.name === fieldName);
    //console.log('Found child field:', field?.name, field?.label);

    const result = field?.label || fieldName;
    //console.log('Child field label result:', result);
    return result;
  }

  // New helper method to check if this is a parent-child filter
  private isParentChildFilter(filter: any): boolean {
    // Check if entity_name corresponds to a parent field in child_data
    const childDataEntry = this.default_data?.child_data?.find(
      (cd: any) => cd.field_name === filter.entity_name && !cd.default
    );
    return !!childDataEntry;
  }

  // New helper method to get display name for parent-child filters
  private getParentChildDisplayName(filter: any): string {
    //console.log('getParentChildDisplayName called with:', filter);

    // Parse the composite key: 'pn~cs' -> parentField='pn', childField='cs'
    const [parentField, childField] = filter.key1.split('~');
    //console.log('Parsed parent field:', parentField, 'child field:', childField);

    // Get the parent field label from the main entity
    const parentFieldLabel = this.getFieldLabelByName(this.actualMainEntity, parentField);
    //console.log('Parent field label:', parentFieldLabel);

    // Resolve child entity via child_data map
    const childMap = this.default_data?.child_data?.find((cd: any) => cd.field_name === parentField);
    if (childMap?.entity_name) {
      const childFieldLabel = this.getChildFieldLabel(childMap.entity_name, childField);
      return `${parentFieldLabel} > ${childFieldLabel}`;
    }
    // Fallback
    return `${parentField} > ${childField}`;
  }



  // Get entity label by name
  getEntityLabelByName(entityName: string): string {
    //console.log('getEntityLabelByName called with:', entityName);
    //console.log('default_data.entity.name:', this.default_data?.entity?.name);

    // Check if it's the main entity
    if (entityName === this.default_data?.entity?.name) {
      const result = this.default_data?.entity?.display_name;
      //console.log('Main entity found, returning:', result);
      return result;
    }

    // Check if it's a child entity by field_name
    const childData = this.default_data?.child_data?.find((c: any) => c.field_name === entityName);
    if (childData) {
      //console.log('Child entity found by field_name:', childData.label);
      return childData.label;
    }

    // Check if it's a child entity by entity_name
    const childDataByEntityName = this.default_data?.child_data?.find((c: any) => c.entity_name === entityName);
    if (childDataByEntityName) {
      //console.log('Child entity found by entity_name:', childDataByEntityName.label);
      return childDataByEntityName.label;
    }

    //console.log('No entity found, returning original:', entityName);
    return entityName;
  }

  // Get field label by name
  // Get field label by name - UPDATED VERSION
  getFieldLabelByName(entityName: string, fieldName: string): string {
    //console.log('getFieldLabelByName called with:', entityName, fieldName);

    // For parent-child filters, we need to find the actual entity
    let actualEntityName = entityName;

    // Check if entityName is a parent field name (like "pn")
    const childDataEntry = this.default_data?.child_data?.find(
      (cd: any) => cd.field_name === entityName
    );

    if (childDataEntry) {
      // This is a parent field, get the actual entity name
      actualEntityName = childDataEntry.entity_name;
      //console.log('Found parent field, actual entity name:', actualEntityName);
    }

    const fields = this.getFields(entityName); // Keep original entityName for getFields
    //console.log('Found fields for entity:', fields);

    const field = fields?.find((f: any) => f.name === fieldName);
    // console.log('Found field:', field);

    const result = field?.label || fieldName;
    //console.log('Field label result:', result);
    return result;
  }
  onSimpleFieldSelection(value: string, filter: any) {
    if (!value) {
      filter.entity_name = '';
      filter.key1 = '';
      filter.key2 = '';
      filter.key3 = '';
      return;
    }

    const [entityName, fieldName] = value.split('|');
    filter.entity_name = entityName;

    // Check if this is a parent-child relationship
    const currentEntityName = this.default_data?.entity?.name;
    if (entityName !== currentEntityName) {
      // This is a parent-child filter, create composite key
      filter.key1 = `${entityName}~${fieldName}`;
    } else {
      filter.key1 = fieldName;
    }

    filter.key2 = '';
    filter.key3 = '';

    const filterIndex = this.filters.indexOf(filter);
    this.filterTypeFieldChange(fieldName, filterIndex, entityName);
  }

  // Get priority fields for main entity
  getMainEntityPriorityFields() {
    return this.default_data?.entity?.fields?.filter((f: any) =>
      f.is_pf === true &&
      f?.datatype !== 'entity' &&
      f?.datatype !== 'textarea'
    )?.sort((a: any, b: any) => a.label?.localeCompare(b.label)) || [];
  }

  // Get non-priority fields for main entity
  getMainEntityNonPriorityFields() {
    return this.default_data?.entity?.fields?.filter((f: any) =>
      f.is_pf !== true &&
      f?.datatype !== 'entity' &&
      f?.datatype !== 'textarea'
    )?.sort((a: any, b: any) => a.label?.localeCompare(b.label)) || [];
  }

  // Get priority fields for child entity
  getChildEntityPriorityFields(entityName: string) {
    const fields = this.getChildEntityAllFields(entityName)?.filter((f: any) => f.is_pf === true) || [];
    return fields;
  }

  // Get non-priority fields for child entity
  getChildEntityNonPriorityFields(entityName: string) {
    const fields = this.getChildEntityAllFields(entityName)?.filter((f: any) => f.is_pf !== true) || [];
    return fields;
  }

  // Get all fields for child entity (helper method)
  getChildEntityAllFields(entityName: string) {
    const fields = this.default_data?.meta_data?.entities
      ?.find((e: any) => e.name === entityName)
      ?.fields?.filter(
        (e: any) =>
          e?.datatype !== 'entity' &&
          e?.datatype !== 'textarea' &&
          this.shouldShowFieldInEntity(e, entityName) // Add this line to apply relationship filtering
      )
      ?.sort((a: any, b: any) => a.label?.localeCompare(b.label)) || [];
    return fields;
  }

  // Filtered priority fields for main entity based on search
  getFilteredMainEntityPriorityFields() {
    const fields = this.getMainEntityPriorityFields();
    if (!this.searchTerm) return fields;
    return fields.filter((field: any) => field.label.toLowerCase().includes(this.searchTerm));
  }

  // Filtered non-priority fields for main entity based on search
  getFilteredMainEntityNonPriorityFields() {
    const fields = this.getMainEntityNonPriorityFields();
    if (!this.searchTerm) return fields;
    return fields.filter((field: any) => field.label.toLowerCase().includes(this.searchTerm));
  }

  // Filtered priority fields for child entity based on search
  getFilteredChildEntityPriorityFields(entityName: string) {
    const fields = this.getChildEntityPriorityFields(entityName);
    if (!this.searchTerm) return fields;
    return fields.filter((field: any) => field.label.toLowerCase().includes(this.searchTerm));
  }

  // Filtered non-priority fields for child entity based on search
  getFilteredChildEntityNonPriorityFields(entityName: string) {
    const fields = this.getChildEntityNonPriorityFields(entityName);
    if (!this.searchTerm) return fields;
    return fields.filter((field: any) => field.label.toLowerCase().includes(this.searchTerm));
  }
  getOperators(field: any, entityName: any): any {
    //console.log('getOperators called with field:', field, 'entityName:', entityName);

    let actualField = field;
    let actualEntityName = entityName;

    // Handle parent-child filters
    if (field && field.includes('~')) {
      // For parent-child filters like 'parentField~childField', resolve child via child_data map
      const [parentField, childField] = field.split('~');
      const childMap = this.default_data?.child_data?.find((cd: any) => cd.field_name === parentField);
      if (childMap?.entity_name) {
        actualField = childField;
        actualEntityName = childMap.entity_name;
      }
    }

    // Determine if this is a child entity by checking if entityName exists in child_data
    const isChildEntity = this.default_data?.child_data?.some((cd: any) =>
      cd.entity_name === actualEntityName || cd.field_name === actualEntityName
    );
    //console.log('isChildEntity:', isChildEntity);

    // Get fields from the correct entity
    let fields;
    if (actualEntityName === this.actualMainEntity) {
      //console.log('Using getFields for main entity');
      fields = this.getFields(actualEntityName);
    } else if (isChildEntity) {
      //console.log('Using getChildEntityFields for child entity');
      // If it's a child entity, get the actual entity name from child_data
      const childDataEntry = this.default_data?.child_data?.find((cd: any) =>
        cd.entity_name === actualEntityName || cd.field_name === actualEntityName
      );
      const actualChildEntityName = childDataEntry?.entity_name || actualEntityName;
      //console.log('Actual child entity name:', actualChildEntityName);
      fields = this.getChildEntityFields(actualChildEntityName);
    } else {
      // console.log('Fallback to getFields');
      // Fallback to getFields for main entity
      fields = this.getFields(actualEntityName);
    }

    //console.log('Fields for operators:', fields?.length || 0);

    const selectedtype = fields?.find((item: any) => item?.name === actualField)?.datatype;
    //console.log('Selected datatype:', selectedtype);

    const operators = datatypesOperator[selectedtype];
    // console.log('Available operators:', operators?.length || 0);

    return operators?.sort((a: any, b: any) =>
      a?.label?.localeCompare(b?.label)
    );
  }

  // Helper method to get child entity fields
  private getChildEntityFields(childEntityName: string) {
    //console.log('getChildEntityFields called with:', childEntityName);

    const childEntity = this.default_data?.meta_data?.entities?.find((e: any) => e.name === childEntityName);
    const fields = childEntity?.fields?.filter(
      (e: any) =>
        e?.datatype !== 'entity' &&
        e?.datatype !== 'textarea'
    );

    //console.log('Child entity fields found:', fields?.length || 0);
    return fields;
  }
  update_includes(value: any, event: any) {
    let input_value = event?.target?.value;
    value.key3 = input_value ? input_value?.split(',') : [];
  }
  set_value(value: any) {
    let set_input_value = Array.isArray(value?.key3)
      ? value.key3.join(',')
      : '';
    return set_input_value;
  }
  findItsDataTypeValue(field: string, entityName: any, operator: string) {
    let actualField = field;
    let actualEntityName = entityName;





    // Handle parent-child filters
    if (field && field.includes('~')) {
      const [parentField, childField] = field.split('~');
      const childMap = this.default_data?.child_data?.find((cd: any) => cd.field_name === parentField);
      if (childMap?.entity_name) {
        actualField = childField;
        actualEntityName = childMap.entity_name;
      }
    }
    // Also handle case where UI stores entity_name as parent field_name and key1 as plain child field name (no ~)
    // CRITICAL FIX: Only lookup if entityName is NOT the main entity to avoid collisions where field name == entity name
    else if (entityName && entityName !== this.actualMainEntity) {
      const childMapByEntityName = this.default_data?.child_data?.find((cd: any) => cd.field_name === entityName);
      if (childMapByEntityName?.entity_name) {
        actualEntityName = childMapByEntityName.entity_name;
      }
    }


    // Get fields from the correct entity - use same logic as getOperators
    let headersField;
    const isChildEntity = this.default_data?.child_data?.some((cd: any) =>
      cd.entity_name === actualEntityName || cd.field_name === actualEntityName
    );

    if (actualEntityName === this.actualMainEntity) {
      headersField = this.getFields(actualEntityName);
    } else if (isChildEntity) {
      // If it's a child entity, get the actual entity name from child_data
      const childDataEntry = this.default_data?.child_data?.find((cd: any) =>
        cd.entity_name === actualEntityName || cd.field_name === actualEntityName
      );
      const actualChildEntityName = childDataEntry?.entity_name || actualEntityName;
      headersField = this.getChildEntityFields(actualChildEntityName);
    } else {
      // Fallback to getFields for main entity
      headersField = this.getFields(actualEntityName);
    }

    let fieldInfo = headersField?.find((e: any) => e?.name == actualField);

    // Rest of your existing logic...
    if (fieldInfo) {
      fieldInfo = { ...fieldInfo }; // Shallow copy

      // Normalize option source for entity-backed inputs
      if (
        ['textbox', 'email', 'website'].includes(fieldInfo.datatype) &&
        (operator === '$in' || operator === '$nin')
      ) {
        fieldInfo.option_type = 'ENTITY_DATA';
      }

      // Don't override option_type - respect the metadata configuration
      // Different dropdowns may use different option types (API, ENTITY_DATA, STATIC)

      // If option source is ENTITY_DATA, set correct target entity/field
      // - For composite keys (parent~child), use resolved child entity/field
      // - Otherwise, keep metadata-provided entity_name/field_name if present
      //   (so dropdowns tied to another entity use that), and only fallback to current
      //   entity/field when metadata doesn't specify
      if (fieldInfo.option_type === 'ENTITY_DATA') {
        const isComposite = typeof field === 'string' && field.includes('~');
        // Only consider it a parent field reference if entityName is a field in the main entity AND exists in child_data
        const mainEntityFields = this.getFields(this.actualMainEntity);
        const isEntityNameAFieldInMainEntity = mainEntityFields?.some((f: any) => f.name === entityName);
        const isParentFieldRef = isEntityNameAFieldInMainEntity && !!this.default_data?.child_data?.find((cd: any) => cd.field_name === entityName);

        // Determine parent FK to use only when we truly have a parent->child selection
        let parentFk: string | null = null;
        if (isComposite) {
          parentFk = String(field).split('~')[0];
        } else if (isParentFieldRef) {
          parentFk = String(entityName); // entityName here is the parent field (e.g., 'pn')
        }

        if (parentFk) {
          fieldInfo.entity_name = actualEntityName; // child entity
          // Fix: Do not overwrite the child field name with the parent FK name.
          // Use the actual selected field on the child entity (e.g. 'rcd_onr_xx' instead of 'fn')
          fieldInfo.field_name = actualField;
        } else {

          // Regular same-entity field
          fieldInfo.entity_name = fieldInfo.entity_name || actualEntityName;
          // Use metadata field_name if it exists and is valid, otherwise use the passed actualField parameter
          fieldInfo.field_name = fieldInfo.field_name || actualField;

        }
      }


      if (fieldInfo?.datatype === 'priority') {
        fieldInfo.option_type = 'STATIC';
      } else if (fieldInfo?.datatype === 'status') {
        fieldInfo.option_type = 'STATIC';
        fieldInfo.options = [
          ...(fieldInfo.open_status || []),
          ...(fieldInfo.close_status || []),
        ];
      }

      fieldInfo.is_unique = false;
      fieldInfo.mandatory = false;
      fieldInfo.num_val = '';
      fieldInfo.num_val_check = '';
      fieldInfo.data_length = '';
      fieldInfo.data_length_check = '';
    }
    return fieldInfo;
  }
  changeOperatorAdd(e: any, i: any) {
    this.filters.map((item: any, index: any) => {
      if (!this.Array.isArray(item)) {
        item.key4 = e;
      } else {
        if (this.Array.isArray(item)) {
          for (let i of item) {
            if (!this.Array.isArray(i)) {
              i.key4 = !e;
            } else {
              if (this.Array.isArray(i)) {
                for (let j of i) {
                  j.key4 = e;
                }
              }
            }
          }
        }
      }
    });
    //console.log(this.filters, ' this.filters')
  }
  changegroupOperatorAdd(e: any, i: any, j: any) {
    this.filters[i].map((item: any, index: any) => {
      if (!this.Array.isArray(item)) {
        item.key4 = e;
      }
    });
  }
  selectedEntities($event: any, filter: any) {
    if ($event) {
      filter.key1 = '';
      filter.key2 = '';
      filter.key3 = '';
      filter.key4 = true;
    }
  }
  filterTypeFieldChangeGroups(event: any, i: any, j: any, entityName: any) {
    const fields = this.getFields(entityName);
    const selectedField = fields?.find((item: any) => item?.name === event);
    if (selectedField) {
      if ([
        'dropdown_single_select',
        'people',
        'dropdown_multi_select',
        'status',
        'tag',
        'priority',
        'phone',
        'website',
        'email',
        'textbox',
        'location',
      ].includes(selectedField?.datatype)) {
        this.filters[i][j].key3 = [];
      }
      if ([
        'currency',
        'progress',
        'number',
        'ratings',
        'rating',
        'time',
      ].includes(selectedField?.datatype)) {
        this.filters[i][j].key3 = null;
      }
      const operators = this.getOperators(this.filters[i][j]?.key1, entityName) || [];
      if ([
        'textbox', 'dropdown_single_select', 'dropdown_multi_select', 'status', 'tag', 'priority', 'phone', 'website', 'people', 'email', 'location'
      ].includes(selectedField?.datatype)) {
        const inOp = operators.find((op: { label: string; value: string }) => op.label === 'in');
        this.filters[i][j].key2 = inOp ? inOp.value : (operators[0]?.value || '');
      } else if (selectedField?.datatype === 'date' || selectedField?.datatype === 'datetime') {
        const btwOp = operators.find((op: { label: string; value: string }) => op.label === 'between');
        this.filters[i][j].key2 = btwOp ? btwOp.value : (operators[0]?.value || '');
      } else if ([
        'number', 'currency', 'progress', 'ratings', 'rating', 'time'
      ].includes(selectedField?.datatype)) {
        const eqOp = operators.find((op: { label: string; value: string }) => op.label === '=' || op.label === 'is');
        this.filters[i][j].key2 = eqOp ? eqOp.value : (operators[0]?.value || '');
      } else if (selectedField?.datatype === 'checkbox') {
        const selOp = operators.find((op: { label: string; value: string }) => op.label === 'is selected');
        this.filters[i][j].key2 = selOp ? selOp.value : (operators[0]?.value || '');
      } else if (selectedField?.datatype === 'attachment') {
        const hasOp = operators.find((op: { label: string; value: string }) => op.label === 'has');
        this.filters[i][j].key2 = hasOp ? hasOp.value : (operators[0]?.value || '');
        this.filters[i][j].key3 = 'true'; // Default to "has" = true
      } else {
        this.filters[i][j].key2 = operators[0]?.value || '';
      }
    }
  }

  filterTypeFieldChangeChildGroups(
    event: any,
    i: any,
    j: any,
    k: any,
    entityName: any
  ) {
    const fields = this.getFields(entityName);
    const selectedField = fields?.find((item: any) => item?.name === event);
    if (selectedField) {
      if ([
        'dropdown_single_select',
        'people',
        'dropdown_multi_select',
        'status',
        'tag',
        'priority',
        'phone',
        'website',
        'email',
        'textbox',
        'location',
      ].includes(selectedField?.datatype)) {
        this.filters[i][j][k].key3 = [];
      }
      if ([
        'currency',
        'progress',
        'number',
        'ratings',
        'rating',
        'time',
      ].includes(selectedField?.datatype)) {
        this.filters[i][j][k].key3 = null;
      }
      const operators = this.getOperators(this.filters[i][j][k]?.key1, entityName) || [];
      if ([
        'textbox', 'dropdown_single_select', 'dropdown_multi_select', 'status', 'tag', 'priority', 'phone', 'website', 'people', 'email', 'location'
      ].includes(selectedField?.datatype)) {
        const inOp = operators.find((op: { label: string; value: string }) => op.label === 'in');
        this.filters[i][j][k].key2 = inOp ? inOp.value : (operators[0]?.value || '');
      } else if (selectedField?.datatype === 'date' || selectedField?.datatype === 'datetime') {
        const btwOp = operators.find((op: { label: string; value: string }) => op.label === 'between');
        this.filters[i][j][k].key2 = btwOp ? btwOp.value : (operators[0]?.value || '');
      } else if ([
        'number', 'currency', 'progress', 'ratings', 'rating', 'time'
      ].includes(selectedField?.datatype)) {
        const eqOp = operators.find((op: { label: string; value: string }) => op.label === '=' || op.label === 'is');
        this.filters[i][j][k].key2 = eqOp ? eqOp.value : (operators[0]?.value || '');
      } else if (selectedField?.datatype === 'checkbox') {
        const selOp = operators.find((op: { label: string; value: string }) => op.label === 'is selected');
        this.filters[i][j][k].key2 = selOp ? selOp.value : (operators[0]?.value || '');
      } else if (selectedField?.datatype === 'attachment') {
        const hasOp = operators.find((op: { label: string; value: string }) => op.label === 'has');
        this.filters[i][j][k].key2 = hasOp ? hasOp.value : (operators[0]?.value || '');
        this.filters[i][j][k].key3 = 'true'; // Default to "has" = true
      } else {
        this.filters[i][j][k].key2 = operators[0]?.value || '';
      }
    }
  }

  inputValueChange(
    event: any,
    fieldProperties: any,
    directive: any,
    rowData: any
  ) {
    if (
      [
        'dropdown_single_select',
        'dropdown_multi_select',
        'status',
        'priority',
      ].includes(fieldProperties.datatype)
    ) {
      if (fieldProperties.option_type == 'ENTITY_DATA') {
        rowData.key3 = event.value.map((r: any) => r.split('___')[0]);
      } else {
        rowData.key3 = event.value;
      }
    } else if (fieldProperties.datatype === 'time') {
      rowData.key3 = event.value.manualtime;
    } else if (fieldProperties.datatype === 'datetime') {
      // Handle datetime values properly to avoid change detection issues
      if (event.value) {
        rowData.key3 = format(new Date(event.value), 'yyyy-MM-dd HH:mm:ss');
      } else {
        rowData.key3 = '';
      }
    } else {
      rowData.key3 = event.value;
    }
  }

  dateTimeFilterChange(event: any, filter: any) {
    if (event) {
      filter.key3 = format(new Date(event), 'yyyy-MM-dd HH:mm:ss');
    } else {
      filter.key3 = '';
    }
  }
  dateTimeOkHandler(event: any, filter: any) {
    const dateValue = event instanceof Date ? event : (event?.date || event);
    this.dateTimeFilterChange(dateValue, filter);
  }
  // Local model to avoid re-entrant change detection loops when formatting strings
  onDateTimeModelChange(dateOrEvent: any, filter: any) {
    const date = this.ensureDate(dateOrEvent);
    filter.__dtModel = date;
    if (date) {
      filter.key3 = format(new Date(date), 'yyyy-MM-dd HH:mm:ss');
    } else {
      filter.key3 = '';
    }
  }

  private ensureDate(val: any): Date | null {
    if (!val) return null;
    if (val instanceof Date) return val;
    // dayjs or moment like objects
    if (typeof val?.toDate === 'function') {
      try { return val.toDate(); } catch { /* ignore */ }
    }
    if (val?.nativeDate instanceof Date) {
      return val.nativeDate;
    }
    if (Array.isArray(val)) {
      const first = val[0];
      if (first instanceof Date) return first;
      if (typeof first?.toDate === 'function') {
        try { return first.toDate(); } catch { /* ignore */ }
      }
    }
    const m = new Date(val);
    return !isNaN(m.getTime()) ? m : null;
  }
  // Convert stored datetime string to Date for binding in template
  getDateTimeModel(value: any): Date | null {
    if (!value) {
      return null;
    }
    if (value instanceof Date) {
      return value;
    }
    const native = new Date(value);
    if (!isNaN(native.getTime())) {
      return native;
    }
    const m = new Date(value);
    return !isNaN(m.getTime()) ? m : null;
  }
  // Normalize format tokens to Angular DatePipe
  getAngularDateFormat(input?: string, fallback: string = 'dd-MM-yyyy HH:mm:ss'): string {
    if (!input || typeof input !== 'string') {
      return fallback;
    }
    let fmt = input;
    fmt = fmt.replace(/YYYY/g, 'yyyy')
      .replace(/YY/g, 'yy')
      .replace(/DD/g, 'dd');
    return fmt;
  }
  set_key2value(event: any, filter: any) {
    // Normalize entity and field for parent-child selections
    let lookupEntity = filter?.entity_name;
    let lookupField = filter?.key1;
    if (typeof filter?.key1 === 'string' && filter.key1.includes('~')) {
      const [parentField, childField] = filter.key1.split('~');
      const childMap = this.default_data?.child_data?.find((cd: any) => cd.field_name === parentField);
      if (childMap?.entity_name) {
        lookupEntity = childMap.entity_name;
        lookupField = childField;
      }
    }
    const fields = this.getFields(lookupEntity);
    const selectedField = fields?.find((item: any) => item?.name === lookupField);
    filter.key2 = event;

    // Special handling for checkbox
    if (selectedField?.datatype === 'checkbox') {
      if (filter.key2 === '' || filter.key2 === undefined) {
        // "is selected" - set key3 to 'true'
        filter.key3 = 'true';
      } else if (filter.key2 === '$ne') {
        // "is not selected" - set key3 to 'true' (we check $ne true to find unchecked)
        filter.key3 = 'true';
      } else if (filter.key2 === '$null') {
        filter.key3 = 'true';
      } else if (filter.key2 === '$nnull') {
        filter.key3 = 'false';
      }
      return;
    }

    if (filter.key2 === '$null') {
      filter.key3 = 'true';
    } else if (filter.key2 === '$nnull') {
      filter.key3 = 'false';
    } else if (filter.key2 === '$has') {
      filter.key3 = 'true';
    } else if (filter.key2 === '$has_not') {
      filter.key3 = 'false'; // Keep key2 as $has_not for UI, but set value to false
    } else if (filter.key2 === '$btw' && selectedField) {
      if (string_datatype?.includes(selectedField?.datatype)) {
        filter.key3 = filter_string;
      } else if (number_datatype?.includes(selectedField?.datatype)) {
        filter.key3 = filter_number;
      }
    }
    else if ((filter.key2 === '$in' || filter.key2 === '$nin') &&
      ['textbox', 'email', 'website'].includes(selectedField?.datatype)) {
      filter.key3 = [];
      //this.loadAutocompleteData(filter.entity_name, filter.key1);
    }
    else {
      if (
        [
          'dropdown_single_select',
          'people',
          'dropdown_multi_select',
          'status',
          'tag',
          'priority',
        ].includes(selectedField?.datatype)
      ) {
        filter.key3 = [];
      } else if (
        ['currency', 'progress', 'number', 'ratings', 'rating', 'time'].includes(
          selectedField?.datatype
        )
      ) {
        filter.key3 = null;
      } else {
        filter.key3 = '';
      }
    }
  }
  key2value(filter: any) {
    if (filter.key2 === '$null' && filter.key3 === 'false') {
      return '$nnull';
    }
    return filter.key2;
  }
}